<template>
  <div id="app">
    <!-- Caricamento iniziale -->
    <div v-if="!isAppReady" class="app-loading">
      <div class="spinner"></div>
      <p>Caricamento...</p>
    </div>

    <!-- App pronta -->
    <router-view v-else />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from './stores/app.js'

const router = useRouter()
const appStore = useAppStore()

// L'app è pronta quando la config è stata caricata e non stiamo authenticando
const isAppReady = computed(() => !appStore.loadingAuth && appStore.hasServerConfig)

// Imposta il tema
document.documentElement.setAttribute('data-theme', 'glass')

onMounted(async () => {
  // OAuth2 callback con hash routing: Keycloak redirecta a /auth/callback?code=xxx
  // ma il router hash si aspetta /#/auth/callback?code=xxx
  // Intercetta il redirect e naviga alla rotta hash corretta (senza reload).
  const currentPath = window.location.pathname
  const currentSearch = window.location.search
  if (currentPath === '/auth/callback' && currentSearch.includes('code=')) {
    const params = new URLSearchParams(currentSearch)
    const hashParams = new URLSearchParams()
    if (params.get('code')) hashParams.set('code', params.get('code'))
    if (params.get('state')) hashParams.set('state', params.get('state'))
    if (params.get('error')) hashParams.set('error', params.get('error'))
    const hashPath = '/auth/callback?' + hashParams.toString()
    window.history.replaceState({}, document.title, '/#' + hashPath)
    router.replace(hashPath)
  }

  try {
    await appStore.fetchServerConfig()
  } catch (e) {
    console.error('Errore caricamento config:', e)
  }
})
</script>

<style>
.app-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--ae-border-color, #e0e0e0);
  border-top-color: var(--ae-primary, #6366f1);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
